import { render, staticRenderFns } from "./cadastro_edicao_supervisor.vue?vue&type=template&id=3d59c176&scoped=true"
import script from "./cadastro_edicao_supervisor.vue?vue&type=script&lang=js"
export * from "./cadastro_edicao_supervisor.vue?vue&type=script&lang=js"
import style0 from "./cadastro_edicao_supervisor.vue?vue&type=style&index=0&id=3d59c176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d59c176",
  null
  
)

export default component.exports